<template>
  <header :class="wrapperDynamicClass" class="header__wrapper">
    <div class="header__container">
      <a-header-logo />
    </div>
  </header>
</template>

<script>
import AHeaderLogo from '@/components/_layout/AHeader/AHeaderLogo/index.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AHeader',
  components: {
    AHeaderLogo
  },
  computed: {
    ...mapGetters({
      isScrollbarHidden: 'isScrollbarHidden'
    }),
    wrapperDynamicClass() {
      return {
        'no-scroll': this.isScrollbarHidden
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$header-y-padding: 34px;

.header__wrapper {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: $z-index-header;
  background: transparent;

  .header__container {
    max-width: $desktop-container;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;

    $padding: (
      $above-desktop-xl: $header-y-padding $padding-x-desktop-full-hd,
      $desktop-md: $header-y-padding $padding-x-desktop-md,
      $mobile: 40px $padding-x-mobile 30px
    );

    $align-items: (
      $tablet: center
    );

    @include setStyleByBreakpoint('align-items', $align-items);
    @include setStyleByBreakpoint('padding', $padding);
  }

  .header__mobile-menu {
    margin-left: auto;
  }
}
</style>
